(function () {
  const STOREFRONT_TOKEN = '369e92cd007a131838c94f814d9d583e';
  const ENDPOINT = 'https://trailstore.cl/api/2025-01/graphql.json';

  const QUERY = `
    query {
      products(first: 20, query: "CamelBak") {
        edges {
          node {
            title
            handle
            onlineStoreUrl
            featuredImage {
              url
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;

  function formatCLP(amount) {
    const n = parseFloat(amount);
    if (!isFinite(n)) return '';
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(n);
  }

  async function init(root) {
    const track = root.querySelector('.camelbak-carousel');
    const prev = root.querySelector('.camelbak-nav.prev');
    const next = root.querySelector('.camelbak-nav.next');

    if (!track) return;

    prev && prev.addEventListener('click', () =>
      track.scrollBy({ left: -320, behavior: 'smooth' })
    );
    next && next.addEventListener('click', () =>
      track.scrollBy({ left: 320, behavior: 'smooth' })
    );

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: QUERY })
      });

      const json = await res.json();
      const products = json?.data?.products?.edges?.map(e => e.node) || [];

      if (!products.length) {
        track.innerHTML = '<div>No se encontraron productos CamelBak.</div>';
        return;
      }

      track.innerHTML = products.map(p => `
        <a class="camelbak-card"
           href="${p.onlineStoreUrl || 'https://trailstore.cl/products/' + p.handle}"
           target="_blank"
           rel="noopener">
          ${p.featuredImage?.url
            ? `<img src="${p.featuredImage.url}" loading="lazy">`
            : ''}
          <div>${p.title}</div>
          <strong>${formatCLP(p.priceRange.minVariantPrice.amount)}</strong>
        </a>
      `).join('');

    } catch (e) {
      track.innerHTML = '<div>Error cargando productos.</div>';
      console.error('CamelBak carousel error:', e);
    }
  }

  function boot() {
    document.querySelectorAll('.camelbak-carousel-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
